/** @jsx jsx */
import { jsx } from '@emotion/core';
import { Button, ButtonGroup, SkeletonBlock } from '@zapier/design-system';
import { useSize } from '@zapier/payment/src/hooks/useSize';

type PaymentFormButtonProps = {
  /** Submit button text */
  buttonText?: string;
  /** Enable submit button */
  canSubmit?: boolean;
  /** Show cancel button */
  hasCancelButton?: boolean;
  /** Show busy indicator on submit button */
  isBusy?: boolean;
  /** On cancel */
  onCancel: () => void;
};

const PaymentFormButtons = (props: PaymentFormButtonProps) => {
  const size = useSize();
  return (
    <ButtonGroup
      columnSize={size === 'small' ? '100%' : 'minmax(100px, 200px)'}
      justify="end"
    >
      {props.hasCancelButton && (
        <Button color="white" onClick={props.onCancel} type="button">
          Cancel
        </Button>
      )}
      {props.isBusy ? (
        <SkeletonBlock height={50} width="100%" />
      ) : (
        <Button disabled={!props.canSubmit} type="submit">
          {props.buttonText}
        </Button>
      )}
    </ButtonGroup>
  );
};

PaymentFormButtons.defaultProps = {
  buttonText: 'Save',
};
export default PaymentFormButtons;
